import React, { FC } from 'react';
import styles from '../RecruiterProfile.module.less';

type Props = {
  text: string;
};
export const NumberView: FC<Props> = (props) => {
  return <div className={styles.numberView}>{props.text}</div>;
};
